import { render } from "./CreatePrefence.vue?vue&type=template&id=275ddfd8"
import script from "./CreatePrefence.vue?vue&type=script&lang=js"
export * from "./CreatePrefence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__